export default __webpack_public_path__ + "static/media/pothos.d72dc0ac.jpg";